var _circle, _path, _path2, _path3, _path4, _path5, _path6, _circle2, _circle3, _path7, _path8, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 141,
    viewBox: "0 0 140 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.7908,
    cy: 64.7649,
    r: 59.2649,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.709 112.618C114.391 111.093 108.75 106.832 112.732 101.989C117.709 95.9339 120.13 98.2212 119.458 100.105C118.785 101.989 113.405 107.774 109.907 102.93C106.41 98.0867 110.042 90.8211 111.387 90.4175M10.6348 48.439C11.3073 50.6814 13.6748 54.7089 17.7641 52.879C22.8757 50.5917 24.0863 47.3626 30.005 52.879C34.7399 57.2922 39.0624 53.8209 40.6317 51.5336M108.562 23.6824C107.172 20.5879 105.226 14.6678 108.562 15.7442C112.732 17.0897 105.872 23.5479 97.5317 15.7442",
    stroke: "#595959",
    strokeWidth: 0.51873
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2544 13.8L76.2569 16.9109L78.7252 18.4686L76.2544 16.9155L73.7836 18.4686L76.2519 16.9109L76.2544 13.8Z",
    fill: "#8C8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9574 72.9351L29.9602 76.4347L32.7651 78.1872L29.9574 76.44L27.1497 78.1872L29.9546 76.4347L29.9574 72.9351Z",
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3682 86.6665L56.6097 92.9081L37.69 111.828C35.9664 113.551 33.172 113.551 31.4484 111.828C29.7249 110.104 29.7249 107.31 31.4484 105.586L50.3682 86.6665Z",
    fill: "#BFBFBF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.021 88.4968L33.1997 104.318",
    stroke: "#595959",
    strokeWidth: 0.51873
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57 78.0845L65.192 86.2765L56.2162 95.2524C55.2033 96.2653 53.5611 96.2653 52.5482 95.2524L48.0241 90.7283C47.0113 89.7154 47.0113 88.0732 48.0241 87.0603L57 78.0845Z",
    fill: "#8C8C8C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.7725,
    cy: 64.1982,
    r: 31.4458,
    transform: "rotate(45 77.7725 64.1982)",
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.6577,
    cy: 64.2696,
    r: 24.274,
    transform: "rotate(90 77.6577 64.2696)",
    fill: "#F5F5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0542 79.9977C100.78 71.2719 100.78 57.1245 92.0542 48.3987",
    stroke: "#BFBFBF",
    strokeWidth: 0.51873
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4755 49.5923C73.9966 49.5923 72.817 50.8271 72.8846 52.3045L73.7274 70.7194C73.7908 72.1043 74.932 73.1945 76.3183 73.1945H77.4842C78.8705 73.1945 80.0117 72.1043 80.0751 70.7194L80.9179 52.3045C80.9855 50.8271 79.806 49.5923 78.327 49.5923H75.4755ZM76.7715 80.4568C78.4904 80.4568 79.8838 79.0633 79.8838 77.3444C79.8838 75.6255 78.4904 74.232 76.7715 74.232C75.0525 74.232 73.6591 75.6255 73.6591 77.3444C73.6591 79.0633 75.0525 80.4568 76.7715 80.4568Z",
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.384,
    cy: 61.5231,
    r: 2.59365,
    fill: "#F0F0F0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEmpty);
export default __webpack_public_path__ + "static/media/search-empty.95b87b7d508f4bcbe5ead612ca57c568.svg";
export { ForwardRef as ReactComponent };